/**
 * ═══════════════════════════════════════════════════════════════════════
 * MARSSEL CONFIGURATION FILE
 * ═══════════════════════════════════════════════════════════════════════
 *
 * Ce fichier centralise tous les styles de composants réutilisables pour
 * votre projet Marssel. Au lieu de surcharger votre HTML avec des classes
 * répétitives dans le <body>, définissez-les ici une seule fois.
 *
 * AVANTAGES :
 * -----------
 * - HTML propre et lisible
 * - Maintenance facilitée (un seul endroit à modifier)
 * - Cohérence visuelle garantie
 * - Performance optimisée (styles compilés au chargement)
 * - Versionnable et réutilisable entre projets
 *
 * UTILISATION :
 * ------------
 * 1. Définissez vos composants ci-dessous
 * 2. Importez ce fichier dans votre app
 * 3. Passez les composants à Marssel lors de l'initialisation
 * 4. Utilisez simplement les classes dans votre HTML
 *
 * EXEMPLE :
 * --------
 * // Dans votre fichier principal
 * import { componentStyles } from './marssel.config.js';
 *
 * const marssel = new Marssel({
 *     theme: 'auto',
 *     components: componentStyles
 * });
 *
 * // Dans votre HTML
 * <button class="btn-1">Mon bouton</button>
 *
 * ═══════════════════════════════════════════════════════════════════════
 */
export const componentStyles = {
    // ═══════════════════════════════════════════════════════════════════
    // BUTTONS - Styles de boutons réutilisables
    // ═══════════════════════════════════════════════════════════════════

    /**
     * btn-1 : Bouton principal sombre
     * État par défaut avec fond mirage et texte blanc
     */

    "btn-1": [
        "bg-[theme-mirage]!",
        "rounded-[100px]!",
        "c-[FFF]!",
        "p-[12px_24px]!",
        "d-[inline-block]",
        "fw-[600]",
        "text-decoration-[none]",
    ],
    "btn-1:hover": ["bg-[theme-peach]!", "color-[theme-mirage]!"],
    "btn-2": [
        "bg-[theme-peach]!",
        "rounded-[100px]!",
        "c-[000]!",
        "p-[12px_24px]!",
        "fw-[600]",
        "text-decoration-[none]",
    ],
    "btn-2:hover": ["bg-[theme-mirage]!", "color-[white]!"],

    h1: [
        "color-[theme-mirage]",
        "position-[relative]",
        "d-[inline-block]",
        "text-shadow-[6px_0px_theme-peach]",
    ],
    h2: ["fs-[32px]", "font-[Sora(700)]", "line-height-[1]", "mb-[0.5rem]"],
    "code-small": [
        "color-[theme-mirage]",
        "bg-[fff1ed]",
        "border-[1px_solid_theme-peach]",
        "fs-[0.9rem]",
        "rounded-[6px]",
        "p-[1px_6px]",
        "fw-[400]",
    ],

    "badge-section": [
        "text-transform-[uppercase]",
        "mb-[2rem]",
        "d-[block]",
        "bg-[D20000]",
        "c-[white]",
        "rounded-[20px]",
        "p-[6px_16px]",
        "w-[fit-content]",
        "mx-[auto]",
        "fs-[12px]",
        "fw-[600]",
    ],
};
